<script>
import Multiselect from "@vueform/multiselect";
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import {Workbook} from "exceljs";
import moment from "moment/moment";

import {
  DxColumn,
  DxColumnChooser, DxColumnFixing,
  DxDataGrid,
  DxExport,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxPager,
  DxRemoteOperations, DxStateStoring,
  DxToolbar,
  DxItem,
  DxButton,
  DxPaging,
} from "devextreme-vue/data-grid";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Log Disparo de Email",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie, Multiselect,
    DxColumnFixing, DxStateStoring, DxGrouping, DxToolbar,
    DxItem, DxGroupPanel, DxColumn, DxDataGrid, DxExport, DxRemoteOperations,
    DxPager, DxFilterRow, DxButton, DxColumnChooser, DxPaging
   }, //DxSummary, DxTotalItem

  data() {
    return {
      animationJson,
      title: "Log's Disparo de Email",
      items: [
        {
          text: "Log's",
          href: '/',
        },
        {
          text: 'Log Disparo de Email',
          active: true,
        },
      ],

      updating: false,
      periodo: null,
      pesqTextFilter: '',
      statusFilter: 'T',
      dtListPesqEmpresas: [],
      empresasSelected: [],
      logsList: [],

      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
    }
  },

  mounted() {
    console.log('mounted logs-disparoEmail-list')
    this.atualizaDataList()
  },

  methods: {
    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios emprepesq')
          console.log(JSON.stringify(res.data))

          this.dtListPesqEmpresas = res.data
        })
      }
    },

    escolheuEmpresa(evt){
      console.log('Empresas selecionadas atualmente:', JSON.stringify(this.empresasSelected));

      const existe = this.empresasSelected.find(item => {
        return item.id === evt
      })

      if (existe) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Empresa já selecionada!",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      const filtros = JSON.parse(localStorage.getItem('filtros')) || {};

      filtros.movdi = moment(this.dtIniFiltro).format('YYYY-MM-DD');
      filtros.movdf = moment(this.dtFimFiltro).format('YYYY-MM-DD');

      localStorage.setItem('filtros', JSON.stringify(filtros));

      this.atualizaDataList()
    },

    atualizaDataList() {
      const filtros = JSON.parse(localStorage.getItem("filtros"));

      if (!filtros) {
        console.log('cookie dataMov não existe, criando e definindo para o mês atual');
        let primeiroDiaMesAtual = moment().startOf('month').format('YYYY-MM-DD');
        let dataAtual = moment().format('YYYY-MM-DD');

        this.dtIniFiltro = primeiroDiaMesAtual;
        this.dtFimFiltro = dataAtual;

        localStorage.setItem(
          'filtros',
          JSON.stringify({
            movdi: primeiroDiaMesAtual,
            movdf: dataAtual,
          })
        );
      } else {
        this.dtIniFiltro = filtros['movdi'];
        this.dtFimFiltro = filtros['movdf'];

        if (!this.dtIniFiltro || !this.dtFimFiltro) {
            console.log('Filtros existentes, mas com datas nulas. Redefinindo para o mês atual.');
            let primeiroDiaMesAtual = moment().startOf('month').format('YYYY-MM-DD');
            let dataAtual = moment().format('YYYY-MM-DD');
            this.dtIniFiltro = primeiroDiaMesAtual;
            this.dtFimFiltro = dataAtual;
            localStorage.setItem(
                'filtros',
                JSON.stringify({
                    movdi: primeiroDiaMesAtual,
                    movdf: dataAtual,
                })
            );
        }
      }

      this.updating = true;
      api.get(`${getBaseUrl()}api/logsdispemail`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro,
          'empresasselected': this.empresasSelected,
        }
      }).then((res) => {
        console.log('then axios');
        console.log(res.data);
        this.updating = false;
        this.logsList = res.data[0];
      }).catch((error) => {
        console.error('Erro na requisição:', error);
        this.updating = false;
      });
    },

    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e);

      this.title = `(${e.component.totalCount()}) Log's Disparo de Email`
    },

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log("refeFormTable");
      this.dataGrid.state(null);
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      return dateTime
    },

    formatDecimal(value){
      // console.log('format_value')
      // console.log('value')
      // console.log('typeof value')
      let value_n = parseFloat(value);
      return Number(value_n).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
    },

  },
}
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 180px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row mt-4" v-if="!updating" style="z-index: 2; position: relative;">
              <h5>Selecione o Período</h5>

              <div class="row col-4">

                <div class="col-6 mb-3">
                  <label for="dtIniFiltro">Dt. Início</label>
                  <input
                      id="dtIniFiltro"
                      v-model="dtIniFiltro"
                      type="date"
                      class="form-control"
                      style="max-width: 200px;"
                      placeholder="Data Início"
                      :class="{'is-invalid': submittedPeriodo && !dtIniFiltro}"
                  />
                  <div v-if="submittedPeriodo && !dtIniFiltro" class="invalid-feedback">
                    <span>Campo data início obrigatório, favor preencher.</span>
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <label for="dtFimFiltro">Dt. Final</label>
                  <input
                      id="dtFimFiltro"
                      v-model="dtFimFiltro"
                      type="date"
                      class="form-control"
                      style="max-width: 200px;"
                      placeholder="Data Final"
                      :class="{'is-invalid': submittedPeriodo && !dtFimFiltro}"
                  />
                  <div v-if="submittedPeriodo && !dtFimFiltro" class="invalid-feedback">
                    <span>Campo data final obrigatória, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-4 ms-auto">
                <label for="empresa">Empresa(s)</label>
                <multiselect id="empresa"
                             @search-change="pesqEmpresa"
                             @select="escolheuEmpresa"
                             v-model="empresasSelected"
                             placeholder="Atual(usuário)"
                             :options="dtListPesqEmpresas"
                             :searchable="true"
                             mode="tags"
                             label="codigo"
                             track-by="id"
                             value-prop="id">
                  <template #option="slotProps">
                    <div class="row">
                      <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                        <span class="mx-4" >
                            </span>
                      </div>
                      <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                      <span class="mx-4" >
                            </span>
                      <span class="mx-4" >
                            </span>
                      <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                    </div>
                  </template>
                </multiselect>
              </div>

              <div class="col-1 ms-auto" style="margin-top: 26px;">
                <b-button variant="primary" style="padding: 8px 50px" @click="confirmarPeriodo">
                  <i class="bx bx-search"></i>
                </b-button>
              </div>
            </div>

            <Loader v-if="updating" style="min-height: 300px;">
            </Loader>
          </div>

          <div class="table-responsive mt-2">
            <div class="card">
              <div class="card-body">
                <div class="mt-4">
                  <DxToolbar>
                    <DxItem location="before" widget="dxButton">
                      <DxButton
                          icon="refresh"
                          hint="Redefinir formatação de tabela para padrão"
                          :on-click="refeFormTable"
                      />
                    </DxItem>
                  </DxToolbar>
                </div>

                <div class="mt-0" v-if="!updating">
                  <DxDataGrid
                      ref="dataGridRefKey"
                      :data-source="logsList"
                      :show-borders="true"
                      :focused-row-enabled="true"
                      :keyExpr="'id'"
                      :column-auto-width="true"
                      :show-row-lines="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      @content-ready="carregouGrid"
                      @exporting="onExporting"
                  >
                    <DxRemoteOperations
                        :filtering="true"
                        :paging="true"
                        :sorting="true"
                        :summary="false"
                        :grouping="false"
                        :group-paging="false"
                    />

                    <DxColumnChooser :enabled="true" />
                    <DxColumnFixing :enabled="true" />
                    <DxFilterRow :visible="false" />

                    <DxExport
                        :enabled="true"
                        :allow-export-selected-data="true"
                    />
                    <DxStateStoring
                        :enabled="true"
                        type="sessionStorage"
                        storage-key="strWmsOsEntradaList"
                    />

                    <DxGroupPanel :visible="false" />
                    <DxGrouping />

                    <DxColumn
                        :width="60"
                        data-field="id"
                        caption="ID"
                        sort-order="desc"
                        data-type="number"
                        alignment="right"
                        :filter-operations="['contains','notcontains','startswith','endswith','=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="empresa_id"
                        caption="ID Empresa"
                        data-type="text"
                        alignment="right"
                        :filter-operations="['contains','notcontains','startswith','endswith','=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="empresanome"
                        caption="Empresa Nome"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains','notcontains','startswith','endswith','=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="origem_id"
                        caption="Origem ID"
                        data-type="text"
                        alignment="right"
                        :filter-operations="['contains','notcontains','startswith','endswith','=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="origem"
                        caption="Origem"
                        data-type="text"
                        alignment="right"
                        :filter-operations="['contains','notcontains','startswith','endswith','=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        :width="180"
                        data-field="log"
                        caption="Log"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        :width="180"
                        data-field="emails"
                        caption="Email's"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                        :allow-sorting="false"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="created_at"
                        caption="Dt Criação"
                        data-type="date"
                        alignment="right"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxPaging :page-size="10" />
                    <DxPager
                        :show-page-size-selector="true"
                        :allowed-page-sizes="[10, 25, 50, 100]"
                        :show-navigation-buttons="true"
                        :show-info="true"
                    />
                  </DxDataGrid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>